//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: String | Object
  },

  data() {
    return {
      file: null,
      preview: null,
    }
  },

  watch: {
    value(current, old) {
      if (current instanceof File) {
        this.file = current
        this.preview = URL.createObjectURL(current)
      }

      if (typeof current === 'string') {
        this.preview = current
      }
    }
  },

  mounted() {
    if (typeof this.value === 'string') {
      this.preview = this.value
    }
  },

  methods: {
    onInput(e) {
      this.$emit('input', e)
    }
  }
}
